import React, { useRef } from "react";
import { newCustomerPasswordPath } from "src/routes";
import { login, LoginResult } from "src/customer/login"
import { ReactComponent as RemoveIcon } from "images/icons/remove.svg?react";

const LoginForm = ({
  initialEmail,
  initialPassword,
  afterLoginCallback,
  onRegisterSelect,
  onClose,
}: {
  initialEmail?: string;
  initialPassword?: string;
  afterLoginCallback: () => void;
  onRegisterSelect: () => void;
  onClose?: () => void;
}) => {
  const [email, setEmail] = React.useState(initialEmail || "");
  const [password, setPassword] = React.useState(initialPassword || "");
  const [errors, setErrors] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const loginFormRef = useRef<HTMLFormElement>(null);

  const handleLoginFormResponse = (response: LoginResult) => {
    if (response.errors) {
      setErrors(response.errors);
    } else {
      afterLoginCallback();
    }

    setPassword("");
    setIsSubmitting(false);
  }

  const handleLoginFormError = () => {
    setErrors(["Error trying to sign in. Please try again later"]);
    setIsSubmitting(false);
    setPassword("");
  }

  const submitLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrors([]);
    setIsSubmitting(true);

    if (!loginFormRef.current) { return; }

    if (loginFormRef.current) {
      const formData = new FormData(loginFormRef.current);
      formData.set("authenticity_token", (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement)?.content || "");

      login(formData)
        .then(handleLoginFormResponse)
        .catch(handleLoginFormError);
    }
  }

  const onRegisterNowSelect = () => {
    if (isSubmitting) { return false; }

    onRegisterSelect();
  }

  const errorComponent = (errors: string[]) => {
    return (
      <div className="error">
        {errors.join(". ")}
      </div>
    );
  }

  return (
    <>
      <section className="divider has-content has-high-contrast is-stuck-top is-layer-middle">
        <h5 className="space-mb-none">Sign in</h5>
        {onClose &&
          <button className="button is-icon-only has-large-icon is-ghost is-aligned-right" name="button" aria-label="Close" onClick={onClose}>
            <RemoveIcon className="icon streamline-icon" />
          </button>
        }
      </section>

      <section className="space-pt-none">
        <form onSubmit={submitLogin} ref={loginFormRef}>
          <fieldset className={errors.length > 0 ? "has-error" : ""}>
            {errors.length > 0 && errorComponent(errors)}

            <div className="text-input has-max-width">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                name="email"
                value={email}
                autoComplete="email"
                onChange={(e) => { setEmail(e.target.value) }}
                required
              />
            </div>

            <div className="text-input has-max-width">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                value={password}
                autoComplete="current-password"
                onChange={(e) => { setPassword(e.target.value) }}
                required
              />
            </div>

            <button type="submit" className="button is-primary" disabled={isSubmitting}>Sign in</button>
          </fieldset>
        </form>

        <br/>
        <p><a href={newCustomerPasswordPath()} className="has-underline space-mb-xs">Forgot your password?</a></p>
        <p>Don&#39;t have an account? <a className="has-underline" onClick={onRegisterNowSelect}>Register now.</a></p>
      </section>
    </>
  );
}

export default LoginForm;
